import { memo } from 'react';
import css from './LegalDocumentModal.module.scss';
import { useLocale, useLocalization } from '../../../context/Localization/localization';
import { Locales, LocalizationType } from '../../../context/Localization/localization.types';
import { GoMotoComponent } from '../../../API/GoMoto.types';
import { GMSizedIcon } from '../../Icon';
import type { LegalDocumentModalProps, LocaleKey } from './LegalDocumentModal.types';

export const LegalDocumentModal: GoMotoComponent<LegalDocumentModalProps> = memo(({ documentType, open, onClose }) => {
    const Localization: LocalizationType = useLocalization();
    const locale: Locales = useLocale();

    const URL_MAP = {
        terms: {
            en: 'https://www.keytrak.com/ext/kiosk-terms',
            fr: 'https://www.keytrak.com/fr/ext/kiosk-terms',
        },
        privacy: {
            en: 'https://www.keytrak.com/ext/kiosk-privacy-rights',
            fr: 'https://www.keytrak.com/fr/ext/kiosk-privacy-rights',
        },
    } as const;

    const localeKey: LocaleKey = locale === Locales.fr ? 'fr' : 'en';
    const url: string = URL_MAP[documentType][localeKey];
    const title: string = documentType === 'terms' ? Localization.TermsOfUse : Localization.PrivacyPolicy;

    if (!open) {
        return null;
    }
    else {
        return (
            <div className={css.popUpContainer}>
                <header className={css.popUpHeader}>
                    <h1 className={css.popUpHeaderTitle}>{title}</h1>
                    <button
                        type={'button'}
                        className={css.closeButton}
                        onClick={onClose}
                        title={Localization.ClickToCloseWindow}
                        aria-label={Localization.ClickToCloseWindow}
                    >
                        <GMSizedIcon
                            iconType={'X'}
                            ariaLabel={''}
                            iconSize={'custom'}
                        />
                    </button>
                </header>
                <div className={css.iframeContainer}>
                    <iframe
                        className={css.iframe}
                        src={url}
                        title={title}
                    />
                </div>
            </div>
        );
    }
});
